import React from "react";
import { Helmet } from "react-helmet";

function HTMLTime() {
  return (
    <div>
      <Helmet>
        <title>HTML Time Newsletter | By Jim</title>
        <meta
          http-equiv="refresh"
          content="0; URL=https://html-time.vercel.app/"
        />
      </Helmet>
    </div>
  );
}

export default HTMLTime;
